<template>
  <div
    v-if="isLoading"
    class="content-loading">
    loading
  </div>
</template>

<script>
import '/static/css/loading.css'
export default {
  name: 'WepLoading',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/loading/WepLoading.vue